import {IvAccountOpeningService} from "./service/IvAccountOpeningService";
import {ivAccountOpeningDialog, IvAccountOpeningDialog} from "./dialog/IvAccountOpeningDialog";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.iv`;

    return angular.module(moduleName, [])
                  .service(IvAccountOpeningService.id, IvAccountOpeningService)
                  .component(IvAccountOpeningDialog, ivAccountOpeningDialog())
                  .name;
}
